import JSONAPISerializer from '@unite-us/json-api-serializer';
import account_role from '../serializers/account_role';
import actor from '../serializers/actor';
import address from '../serializers/address';
import assistance_request from '../serializers/assistance_request';
import assistance_request_config from '../serializers/assistance_request_config';
import attachment from '../serializers/attachment';
import authorized_spend from '../serializers/authorized_spend';
import batch_accepted from '../serializers/batch_accepted';
import batch_data from '../serializers/batch_data';
import batch_job_data from '../serializers/batch_job_data';
import kase from '../serializers/case';
import case_summary from '../serializers/case_summary';
import client_relationship from '../serializers/client_relationship';
import communication from '../serializers/communication';
import consent from '../serializers/consent';
import consent_agreement from '../serializers/consent_agreement';
import contact_preference from "../serializers/contact_preference";
import directory from '../serializers/directory';
import directory_configuration from '../serializers/directory_configuration';
import eligibility from "../serializers/eligibility";
import emr_user from '../serializers/emr_user';
import empi_person from '../serializers/empi_person';
import employee from '../serializers/employee';
import employee_notification from '../serializers/employee_notification';
import enrollment_disenroll_reason from "../serializers/enrollment_disenroll_reason";
import enrollment_rejection_reason from "../serializers/enrollment_rejection_reason";
import enrollment_request from '../serializers/enrollment_request';
import event from '../serializers/event';
import export_type from '../serializers/export';
import favorite from "../serializers/favorite";
import fee_schedule from '../serializers/fee_schedule';
import fee_schedule_program from '../serializers/fee_schedule_program';
import file_upload from '../serializers/file_upload';
import form from '../serializers/form';
import form_need_configuration from '../serializers/form_need_configuration';
import form_submission from '../serializers/form_submission';
import form_usage from '../serializers/form_usage';
import insurance from "../serializers/insurance";
import invitation from '../serializers/invitation';
import invoice from '../serializers/invoice';
import invoice_dispute_reason from '../serializers/invoice_dispute_reason';
import invoice_dispute_resolution_reason from '../serializers/invoice_dispute_resolution_reason';
import invoice_export from '../serializers/invoice_export';
import invoice_rejection_reason from '../serializers/invoice_rejection_reason';
import invoiced_spend from '../serializers/invoiced_spend';
import journey from '../serializers/journey';
import location from '../serializers/location';
import network from '../serializers/network';
import network_lead_relationship from '../serializers/network_lead_relationship';
import note from '../serializers/note';
import outcome from '../serializers/outcome';
import payer from '../serializers/payer';
import person from '../serializers/person';
import person_duplicate from '../serializers/person_duplicate';
import personal_relationship from '../serializers/personal_relationship';
import people_comparison from '../serializers/people_comparison';
import place_of_service from '../serializers/place_of_service';
import plan from '../serializers/plan';
import procedure_code from '../serializers/procedure_code';
import procedure_code_modifier from '../serializers/procedure_code_modifier';
import program from '../serializers/program';
import program_accessibility_option from '../serializers/program_accessibility_option';
import program_city from '../serializers/program_city';
import program_county from '../serializers/program_county';
import program_postal_code from '../serializers/program_postal_code';
import program_requirement_option from '../serializers/program_requirement_option';
import program_state from '../serializers/program_state';
import provided_service from '../serializers/provided_service';
import provider from '../serializers/provider';
import provider_agreement from '../serializers/provider_agreement';
import referral from '../serializers/referral';
import referral_permission from '../serializers/referral_permission';
import resource_list from '../serializers/resource_list';
import resource_list_program_service from '../serializers/resource_list_program_service';
import role from '../serializers/role';
import saml_configuration from '../serializers/saml_configuration';
import scim_configuration from '../serializers/scim_configuration';
import service from '../serializers/service';
import service_area from '../serializers/service_area';
import service_authorization from "../serializers/service_authorization";
import service_authorization_denial_reason from "../serializers/service_authorization_denial_reason";
import share_event from '../serializers/share_event';
import tag from '../serializers/tag';
import user from '../serializers/user';
import user_archive from "../serializers/user_archive";
import user_invites from '../serializers/user_invites';
import version from '../serializers/version';
import x12_rejection_reason from "../serializers/x12_rejection_reason";
import zcode from '../serializers/zcode';
import share from '../serializers/share';
var registerDefaultResources = function registerDefaultResources(serializer) {
  serializer.register(account_role.type, account_role.config);
  serializer.register(actor.type, actor.config);
  serializer.register(address.type, address.config);
  serializer.register(assistance_request.type, assistance_request.config);
  serializer.register(assistance_request_config.type, assistance_request_config.config);
  serializer.register(attachment.type, attachment.config);
  serializer.register(authorized_spend.type, authorized_spend.config);
  serializer.register(batch_accepted.type, batch_accepted.config);
  serializer.register(batch_data.type, batch_data.config);
  serializer.register(batch_job_data.type, batch_job_data.config);
  serializer.register(case_summary.type, case_summary.config);
  serializer.register(client_relationship.type, client_relationship.config);
  serializer.register(communication.type, communication.config);
  serializer.register(consent.type, consent.config);
  serializer.register(consent_agreement.type, consent_agreement.config);
  serializer.register(contact_preference.type, contact_preference.config);
  serializer.register(eligibility.type, eligibility.config);
  serializer.register(emr_user.type, emr_user.config);
  serializer.register(empi_person.type, empi_person.config);
  serializer.register(employee.type, employee.config);
  serializer.register(employee_notification.type, employee_notification.config);
  serializer.register(enrollment_disenroll_reason.type, enrollment_disenroll_reason.config);
  serializer.register(enrollment_rejection_reason.type, enrollment_rejection_reason.config);
  serializer.register(enrollment_request.type, enrollment_request.config);
  serializer.register(event.type, event.config);
  serializer.register(export_type.type, export_type.config);
  serializer.register(favorite.type, favorite.config);
  serializer.register(fee_schedule.type, fee_schedule.config);
  serializer.register(fee_schedule_program.type, fee_schedule_program.config);
  serializer.register(file_upload.type, file_upload.config);
  serializer.register(form.type, form.config);
  serializer.register(form_need_configuration.type, form_need_configuration.config);
  serializer.register(form_submission.type, form_submission.config);
  serializer.register(form_usage.type, form_usage.config);
  serializer.register(insurance.type, insurance.config);
  serializer.register(invoice.type, invoice.config);
  serializer.register(invoice_dispute_reason.type, invoice_dispute_reason.config);
  serializer.register(invoice_dispute_resolution_reason.type, invoice_dispute_resolution_reason.config);
  serializer.register(invoice_export.type, invoice_export.config);
  serializer.register(invoice_rejection_reason.type, invoice_rejection_reason.config);
  serializer.register(invoiced_spend.type, invoiced_spend.config);
  serializer.register(journey.type, journey.config);
  serializer.register(kase.type, kase.config);
  serializer.register(location.type, location.config);
  serializer.register(network.type, network.config);
  serializer.register(network_lead_relationship.type, network_lead_relationship.config);
  serializer.register(note.type, note.config);
  serializer.register(outcome.type, outcome.config);
  serializer.register(payer.type, payer.config);
  serializer.register(person.type, person.config);
  serializer.register(person_duplicate.type, person_duplicate.config);
  serializer.register(personal_relationship.type, personal_relationship.config);
  serializer.register(people_comparison.type, people_comparison.config);
  serializer.register(place_of_service.type, place_of_service.config);
  serializer.register(plan.type, plan.config);
  serializer.register(procedure_code.type, procedure_code.config);
  serializer.register(procedure_code_modifier.type, procedure_code_modifier.config);
  serializer.register(program.type, program.config);
  serializer.register(program_accessibility_option.type, program_accessibility_option.config);
  serializer.register(program_city.type, program_city.config);
  serializer.register(program_county.type, program_county.config);
  serializer.register(program_postal_code.type, program_postal_code.config);
  serializer.register(program_requirement_option.type, program_requirement_option.config);
  serializer.register(program_state.type, program_state.config);
  serializer.register(provided_service.type, provided_service.config);
  serializer.register(provider.type, provider.config);
  serializer.register(provider_agreement.type, provider_agreement.config);
  serializer.register(referral.type, referral.config);
  serializer.register(referral_permission.type, referral_permission.config);
  serializer.register(resource_list.type, resource_list.config);
  serializer.register(resource_list_program_service.type, resource_list_program_service.config);
  serializer.register(role.type, role.config);
  serializer.register(service.type, service.config);
  serializer.register(service_area.type, service_area.config);
  serializer.register(service_authorization.type, service_authorization.config);
  serializer.register(service_authorization_denial_reason.type, service_authorization_denial_reason.config);
  serializer.register(share_event.type, share_event.config);
  serializer.register(tag.type, tag.config);
  serializer.register(user_archive.type, user_archive.config);
  serializer.register(user_invites.type, user_invites.config);
  serializer.register(version.type, version.config);
  serializer.register(x12_rejection_reason.type, x12_rejection_reason.config);
  serializer.register(zcode.type, zcode.config);
  // prd
  serializer.register(directory.type, directory.config);
  serializer.register(directory_configuration.type, directory_configuration.config);
  // auth
  serializer.register(invitation.type, invitation.config);
  serializer.register(saml_configuration.type, saml_configuration.config);
  serializer.register(scim_configuration.type, scim_configuration.config);
  serializer.register(user.type, user.config);
  serializer.register(share.type, share.config);
};
export var buildSerializer = function buildSerializer() {
  var serializer = new JSONAPISerializer();
  registerDefaultResources(serializer);
  return serializer;
};
//# sourceMappingURL=buildSerializer.js.map